import { connect } from "react-redux";
import TypologiesList from "./TypologiesList";

import { init, getReferentielsList } from 'redux/actions/referentielsActions';

const mapStateToProps = (state, ownProps) => {
	return {
		typologiesList: state.typologies.typologiesList,
		page: state.typologies.page,
		pages: state.typologies.pages,
		pageSize: state.typologies.pageSize,
		nbItems: state.typologies.typologiesList.length,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		init: sectionName => dispatch(init(sectionName)),
		getNext: page => {
			const nextPage = page;
			
			dispatch(getReferentielsList({ page: nextPage }, "typologies"));
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(TypologiesList);


// WEBPACK FOOTER //
// src/containers/admin/typologies/TypologiesContainer.js